export const SITE_ORIGIN = "https://nkadimengdannylcs.com";

export const PUBLIC_TOOLS = [
  {
    id: "humaniser",
    path: "/tools/humaniser",
    name: "AI Humaniser",
    pageTitle: "AI Humaniser — Rewrite AI Text Naturally | Nkadimeng Danny",
    description:
      "Rewrite AI-sounding text into natural, professional prose. Fix grammar or strip repetition without losing citations. Free for up to 300 words.",
    freeLabel: "Free for anything up to 300 words",
    paidLabel: "1 credit for longer rewrites",
    creditScope: "tools-humanise",
  },
  {
    id: "paraphraser",
    path: "/tools/paraphraser",
    name: "AI Paraphraser",
    pageTitle: "AI Paraphraser — Formal, Simple, Shorten or Expand | Nkadimeng Danny",
    description:
      "Rewrite passages in a formal, plain, shorter or expanded voice — while keeping every citation, name and figure. 3 free paraphrases a day, then 1 credit each.",
    freeLabel: "3 free paraphrases per day",
    paidLabel: "1 credit per paraphrase after that",
    creditScope: "tools-paraphrase",
  },
  {
    id: "ocr",
    path: "/tools/ocr",
    name: "OCR Scanner",
    pageTitle: "OCR Scanner — Extract Text from Images | Nkadimeng Danny",
    description:
      "Extract text from IDs, contracts, invoices and court documents in all 11 official South African languages. First scan every day is free.",
    freeLabel: "1 free scan per day",
    paidLabel: "1 credit per scan after that",
    creditScope: "tools-ocr",
  },
  {
    id: "pdf",
    path: "/tools/pdf",
    name: "PDF Toolkit",
    pageTitle: "PDF Toolkit — Merge, Split, Rotate & Extract PDFs | Nkadimeng Danny",
    description:
      "Merge, split, rotate and extract pages from PDF files right in your browser — nothing is uploaded, files never leave your device.",
    freeLabel: "Free & unlimited",
    paidLabel: "No account needed",
    creditScope: null,
  },
] as const;

export type PublicTool = (typeof PUBLIC_TOOLS)[number];
export type PublicToolId = PublicTool["id"];

export function getPublicTool(id: PublicToolId) {
  return PUBLIC_TOOLS.find((tool) => tool.id === id)!;
}

export function absoluteUrl(path: string) {
  return `${SITE_ORIGIN}${path}`;
}